
import { TextareaHTMLAttributes, forwardRef } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, className = '', rows = 4, maxLength = 500, ...props }, ref) => {
    return (
      <div className="space-y-2">
        {label && (
          <label className="block text-sm font-medium text-neutral-700">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-colors resize-none text-sm sm:text-base ${error ? 'border-red-500' : ''} ${className}`}
          rows={rows}
          maxLength={maxLength}
          {...props}
        />
        <div className="flex justify-between items-center">
          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
          <p className="text-xs text-neutral-500 ml-auto">
            Máximo {maxLength} caracteres
          </p>
        </div>
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
